import { render, staticRenderFns } from "./form-login-video-second-factor-layout.vue?vue&type=template&id=66ff1c89&"
import script from "./form-login-video-second-factor-layout.vue?vue&type=script&lang=js&"
export * from "./form-login-video-second-factor-layout.vue?vue&type=script&lang=js&"
import style0 from "./form-login-video-second-factor-layout.vue?vue&type=style&index=0&lang=stylus&"


/* normalize component */
import normalizer from "!../../../../../../../tmp/ffsecurity-ui/node_modules/@vue/cli-service/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports